/**
 * @format
 */
import {TOGGLE_CE_TEMP_LOADING} from '../types';

const INITIAL_STATE = {
  loading: false,
};

export const CETempReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case TOGGLE_CE_TEMP_LOADING:
      return {
        ...state,
        loading: action.value,
      };
    default:
      return state;
  }
};
